"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventHighchartsOptionsProvider = void 0;
const highcharts_1 = __importDefault(require("highcharts"));
const lodash_1 = __importDefault(require("lodash"));
const Utils_1 = require("src/hello_assets/src/components/system/util/Utils");
const DateTimeFacade_1 = require("src/hello_assets/src/util/DateTimeFacade");
const HighchartsCalculationsCommonUtils_1 = require("src/hello_assets/src/util/HighchartsCalculationsCommonUtils");
const AggregationJSONModel_1 = require("src/hello_assets/src/components/model/common/AggregationJSONModel");
const HighchartsOptionsProviderCommon_1 = require("src/hello_assets/src/util/HighchartsOptionsProviderCommon");
const CommonTypesConversions_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/CommonTypesConversions");
const ICEventQueryUtil_1 = require("src/hello_assets/src/util/ICEventQueryUtil");
const seriesForChartLastNIntervalData = (lastNIntervalData, parameters, queryEventVariantComposite) => {
    if (!lastNIntervalData) {
        return undefined;
    }
    const initialMoment = DateTimeFacade_1.DateTimeFacade.getMomentFromMillis(lastNIntervalData.intervalStartTimeSec * 1000).startOf("day");
    const numbersData = lodash_1.default.map(lastNIntervalData.data, (value, index) => {
        const day = initialMoment.clone().add(index, "day").startOf("day");
        const pointMillis = day.valueOf();
        return { x: pointMillis, y: value };
    });
    if (parameters.isCumulative) {
        let sum = 0;
        lodash_1.default.each(numbersData, point => {
            sum += point.y;
            point.y = sum;
        });
    }
    const queryEventVariant = CommonTypesConversions_1.CommonTypesConversions.queryEventVariant.queryEventVariantCompositeToQueryEventVariant(queryEventVariantComposite);
    const seriesName = queryEventVariant ? ICEventQueryUtil_1.ICEventQueryUtil.stringifyQueryEventVariant(queryEventVariant) : "";
    const currentSeries = {
        type: "line",
        data: numbersData,
        name: (0, Utils_1.truncateMiddle)(seriesName || "", 30),
        showInLegend: !lodash_1.default.isEmpty(seriesName),
        connectNulls: true,
        custom: {
            seriesName: (0, Utils_1.truncateMiddle)(seriesName || "", 30)
        }
    };
    return currentSeries;
};
const optionsForChartLastNIntervalDataSeries = (series, parameters) => {
    const title = parameters.chartTitle;
    const tooltip = {
        useHTML: true,
        shared: true,
        formatter: function () {
            if (lodash_1.default.isEmpty(this.points)) {
                return "";
            }
            let pointsTableHTML = HighchartsOptionsProviderCommon_1.HighchartsOptionsProviderCommon.TooltipFormatter.shared.tableOpen();
            lodash_1.default.each(lodash_1.default.sortBy(this.points, v => -v.y), point => {
                const custom = point.series.options.custom;
                const name = (0, Utils_1.truncateMiddle)((custom === null || custom === void 0 ? void 0 : custom.seriesName) || point.series.name || "", 60);
                const value = parameters.asPercents ? (0, HighchartsCalculationsCommonUtils_1.numberFormat)(point.y, 2) : point.y;
                const postfix = parameters.asPercents ? "%" : "";
                pointsTableHTML += HighchartsOptionsProviderCommon_1.HighchartsOptionsProviderCommon.TooltipFormatter.shared.pointRow(point.color, name, value, postfix);
            });
            const timestamp = new Date(this.x).getTime();
            const date = highcharts_1.default.dateFormat(DateTimeFacade_1.HighchartsDateFormatByFunctionality.Common.tooltip.daily, timestamp);
            const headerHTML = `<span>${date}</span><br/>`;
            pointsTableHTML += HighchartsOptionsProviderCommon_1.HighchartsOptionsProviderCommon.TooltipFormatter.shared.tableClose();
            return `${headerHTML}${pointsTableHTML}`;
        }
    };
    const yAxis = {
        title: undefined,
        min: 0,
        allowDecimals: false,
        labels: {
            formatter: function () {
                if (parameters.asPercents) {
                    return `${this.value}%`;
                }
                else {
                    return `${this.value}`;
                }
            }
        }
    };
    if (parameters.asPercents) {
        yAxis.maxPadding = 0;
    }
    return {
        exporting: {
            filename: (0, HighchartsCalculationsCommonUtils_1.getExportFilename)(title || "chart")
        },
        chart: { zoomType: "x", },
        title: { text: title },
        series: series,
        xAxis: {
            type: 'datetime',
            dateTimeLabelFormats: DateTimeFacade_1.HighchartsDateFormatByFunctionality.Common.xAxis.dateTimeLabelFormats,
            minTickInterval: 24 * 60 * 60 * 1000,
            startOnTick: false,
            endOnTick: false,
        },
        yAxis: yAxis,
        tooltip: tooltip,
    };
};
const getEvents = (data, parameters, chartStatus) => {
    const activeUsers = parameters.aggregation === AggregationJSONModel_1.Aggregation.dau ? data === null || data === void 0 ? void 0 : data.dau :
        parameters.aggregation === AggregationJSONModel_1.Aggregation.wau ? data === null || data === void 0 ? void 0 : data.wau : data === null || data === void 0 ? void 0 : data.mau;
    if ((data === null || data === void 0 ? void 0 : data.uniques) && activeUsers) {
        let uniques = parameters.sortByAccumulate ? lodash_1.default.sortBy(data.uniques, v => {
            var _a;
            return -lodash_1.default.sum((_a = v.value) === null || _a === void 0 ? void 0 : _a.data);
        }) : data.uniques;
        if (parameters.asPercents) {
            uniques = eventsUniquesPercentFromActiveUsers(uniques, activeUsers);
        }
        const series = lodash_1.default.compact(lodash_1.default.map(uniques, (dashboardEventData) => {
            return seriesForChartLastNIntervalData(dashboardEventData.value, { isCumulative: parameters.isCumulative }, dashboardEventData.queryEventVariant);
        }));
        if (lodash_1.default.isEmpty(parameters.chartTitle)) {
            switch (parameters.aggregation) {
                case AggregationJSONModel_1.Aggregation.dau: {
                    parameters.chartTitle = parameters.asPercents ? "% from DAU" : "Daily Uniques";
                    break;
                }
                case AggregationJSONModel_1.Aggregation.wau: {
                    parameters.chartTitle = parameters.asPercents ? "% from WAU" : "Weekly Uniques";
                    break;
                }
                case AggregationJSONModel_1.Aggregation.mau: {
                    parameters.chartTitle = parameters.asPercents ? "% from MAU" : "Monthly Uniques";
                    break;
                }
            }
        }
        return {
            options: optionsForChartLastNIntervalDataSeries(series, parameters),
            chartStatus: chartStatus
        };
    }
    if ((chartStatus === null || chartStatus === void 0 ? void 0 : chartStatus.status) === "notLoaded") {
        const lastNDays = 30;
        const lastNIntervalData1 = {
            data: Int32Array.from(HighchartsCalculationsCommonUtils_1.HighchartsRandomChartGenerator.random2(lastNDays)),
            intervalStartTimeSec: DateTimeFacade_1.DateTimeFacade.getMomentFromCurrentDayEndOf().subtract(lastNDays, "day").valueOf()
        };
        const lastNIntervalData2 = {
            data: Int32Array.from(HighchartsCalculationsCommonUtils_1.HighchartsRandomChartGenerator.random2(lastNDays, { r1: 1, r2: 10 })),
            intervalStartTimeSec: DateTimeFacade_1.DateTimeFacade.getMomentFromCurrentDayEndOf().subtract(lastNDays, "day").valueOf()
        };
        const lastNIntervalData3 = {
            data: Int32Array.from(HighchartsCalculationsCommonUtils_1.HighchartsRandomChartGenerator.random2(lastNDays, { r1: 2, r2: 20 })),
            intervalStartTimeSec: DateTimeFacade_1.DateTimeFacade.getMomentFromCurrentDayEndOf().subtract(lastNDays, "day").valueOf()
        };
        const series = lodash_1.default.compact([
            seriesForChartLastNIntervalData(lastNIntervalData3, { isCumulative: false }, CommonTypesConversions_1.CommonTypesConversions.queryEventVariant.eventNameToQueryEventVariantComposite("Like")),
            seriesForChartLastNIntervalData(lastNIntervalData2, { isCumulative: false }, CommonTypesConversions_1.CommonTypesConversions.queryEventVariant.eventNameToQueryEventVariantComposite("Comment")),
            seriesForChartLastNIntervalData(lastNIntervalData1, { isCumulative: false }, CommonTypesConversions_1.CommonTypesConversions.queryEventVariant.eventNameToQueryEventVariantComposite("Post")),
        ]);
        return {
            options: optionsForChartLastNIntervalDataSeries(series, parameters),
            chartStatus: chartStatus
        };
    }
    return {
        options: {},
        chartStatus: chartStatus
    };
};
const eventsUniquesPercentFromActiveUsers = (uniques, activeUsers) => {
    const result = lodash_1.default.compact(lodash_1.default.map(uniques, (dashboardEventData) => {
        var _a;
        let chartLastNIntervalData = undefined;
        if (((_a = dashboardEventData.value) === null || _a === void 0 ? void 0 : _a.data) && (activeUsers === null || activeUsers === void 0 ? void 0 : activeUsers.data)) {
            const data = lodash_1.default.map(dashboardEventData.value.data, (value, idx) => {
                if (activeUsers.data[idx] !== 0) {
                    return value * 100 / activeUsers.data[idx];
                }
                else {
                    return 0;
                }
            });
            chartLastNIntervalData = {
                intervalStartTimeSec: dashboardEventData.value.intervalStartTimeSec,
                data: Int32Array.from(data)
            };
        }
        return {
            queryEventVariant: dashboardEventData.queryEventVariant,
            value: chartLastNIntervalData
        };
    }));
    return result;
};
exports.EventHighchartsOptionsProvider = {
    getEvents: getEvents
};
